import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { NumberFormatSeparator } from 'enums-lib';
import { IntegerFormatOptions } from 'interfaces-lib';
import { FieldConfigChangedControllerService } from '../../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-format-integer',
    templateUrl: './format-integer.component.html',
    styleUrls: ['../format-number.component.scss', '../../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class FormatIntegerComponent implements OnInit {
  @Input() set fieldOptions(fieldOptions: IntegerFormatOptions | undefined) {
    this.initFieldOptions(fieldOptions);
    this.hasChanged = false;
  }
  @Output() fieldOptionsChange = new EventEmitter<IntegerFormatOptions>();

  expanded = false;
  hasChanged = false;
  minimumIntegerDigits = 0;
  thousandsSeparator: NumberFormatSeparator | undefined;

  readonly NumberFormatSeparator = NumberFormatSeparator;

  constructor(private configChangedControllerService: FieldConfigChangedControllerService) {}

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('FormatIntegerComponent');
  }

  isValid(): boolean {
    return this.minimumIntegerDigits == 0 && this.thousandsSeparator !== undefined;
  }

  getFormatOption(): IntegerFormatOptions | undefined {
    return this.isValid()
      ? {
          minimumIntegerDigits: this.minimumIntegerDigits!,
          thousandsSeparator: this.thousandsSeparator!,
        }
      : undefined;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  updateConfig(): void {
    this.fieldOptionsChange.emit(this.getFormatOption());
    this.configChangedControllerService.update('FormatIntegerComponent', true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  private initFieldOptions(fieldOptions: IntegerFormatOptions | undefined) {
    if (fieldOptions) {
      this.thousandsSeparator = fieldOptions.thousandsSeparator;
      this.minimumIntegerDigits = fieldOptions.minimumIntegerDigits;
    }
  }
}
